import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';

class Sidebar extends React.Component {
  selectSidebarItem = (index) => {
    const { selectSidebarItemAction, routeId, stopId } = this.props;
    selectSidebarItemAction({ index, routeId, stopId });
  };

  componentDidMount() {
    const { selectSidebarItemAction, routeId, stopId } = this.props;

    if(stopId !== 'without-stop') {
      selectSidebarItemAction({ index: 1, routeId, stopId });
    }
  }

  getSurveysCountResource = (count) => {
    switch (parseInt(count, 10)) {
      case 0:
        return ['routeSurveyModal.noSurvey'];
      case 1:
        return ['routeSurveyModal.oneSurvey'];
      default:
        return ['routeSurveyModal.surveysCount', count];
    }
  };

  renderSidebarItem = (item, index) => {
    const { selectedIndex } = this.props;
    const isStop = !!item.get('stopId');

    const sidebarStopDescription = item.hasIn(['location', 'key']) ?
      `${item.getIn(['location', 'key'])} - ${item.getIn(['location', 'description'])}` :
      item.getIn(['location', 'description']);
    const sidebarDescription = isStop ? sidebarStopDescription :
      Monet.I18n.getResourcesByKey('routeSurveyModal.routeSurveys');
    const itemClassNameSuffix = selectedIndex === index ? 'selected' : '';

    return isStop && (
      <div
        className={`route-survey-modal__sidebar-item ${itemClassNameSuffix}`}
        key={`sidebarItem${index}`}
        onClick={() => this.selectSidebarItem(index)}
      >
        <div className="route-survey-modal__sidebar-item-content">
          { item.has('actualSequenceNum') && (
            <div className="route-survey-modal__sidebar-item-number">
              { item.get('actualSequenceNum') }
            </div>
          ) }
          <div className="route-survey-modal__sidebar-item-description">
            { sidebarDescription }
          </div>
          <div className="route-survey-modal__sidebar-item-count">
            { Monet.I18n.getResourcesByKey(...this.getSurveysCountResource(item.get('surveys').size)) }
          </div>
        </div>
      </div>
    );
  };

  renderSidebarNoItems = () => {
    const { stop } = this.props;

    const sidebarDescription = stop.hasIn(['location', 'key']) ? `${stop.getIn(['location', 'key'])} - ${stop.getIn(['location', 'description'])}` : stop.getIn(['location', 'description']);

    return (
      <div
        className={`route-survey-modal__sidebar-item selected`}
      >
        <div className="route-survey-modal__sidebar-item-content">
          { stop.has('actualSequenceNum') && (
            <div className="route-survey-modal__sidebar-item-number">
              { stop.get('actualSequenceNum') }
            </div>
          ) }
          <div className="route-survey-modal__sidebar-item-description">
            { sidebarDescription }
          </div>
          <div className="route-survey-modal__sidebar-item-count">
            { Monet.I18n.getResourcesByKey('routeSurveyModal.noSurvey') }
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { surveyData } = this.props;

    return (
      <div data-testid="route-survey-modal__sidebar" className="route-survey-modal__sidebar">
        {surveyData.size > 0 ? surveyData.map(this.renderSidebarItem) : this.renderSidebarNoItems()}
      </div>
    );
  }
}

Sidebar.propTypes = {
  // state
  stop: PropTypes.object.isRequired,
  routeId: PropTypes.string.isRequired,
  stopId: PropTypes.string,
  surveyData: PropTypes.object.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  // actions
  selectSidebarItemAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, { routeId, stopId }) => ({
  stop: state.stopDetailsPopup.getIn([String(routeId), String(stopId), 'stop'], Map({})),
  surveyData: selectors.getSurveyModalData(state, String(routeId), String(stopId)),
  selectedIndex: selectors.getSelectedIndex(state, String(routeId), String(stopId))
});

const mapDispatchToProps = {
  selectSidebarItemAction: actionCreators.selectSidebarItem
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
